import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Header from './Header';
import Home from './Home';
import PrivacyPolicy from './PrivacyPolicy';
import Footer from './Footer';
import './index.css';

const scrollToTop = () => {
  window.scrollTo(0, 0);
  return null;
};

const App = () => (
  <Router>
    <div className="App">
      <div className="wrapper">
        <Route component={scrollToTop} />
        <Header />
        <main>
          <Route exact path="/" component={Home} />
          <Route path="/privacy-policy" component={PrivacyPolicy} />
        </main>
      </div>
      <Footer />
    </div>
  </Router>
);

export default App;



// WEBPACK FOOTER //
// ./src/App/index.js